import * as React from 'react'
import { Helmet } from 'react-helmet'

import PickupLocationInput from '../../../components/organisms/wizard/acute/PickupLocationInput'

export default class WizardContactScreen extends React.Component {
  render() {
    const metaTitle = 'Bestattungsplanung | Benu'
    const metaDesc =
      'Planen und beauftragen Sie eine Bestattung online in vertrauter Umgebung. ✓ Alle Bestattungsarten ✓ In ganz Österreich ✓ Persönliche Beratung ✓ Faire & Transparente Preise ▻ jetzt transparentes Angebot online gestalten!'
    const metaUrl = `https://www.benu.at${location.pathname}`
    const metaImg = 'http://dev.benu.at/benu_logo.png'

    return (
      <div>
        <Helmet>
          <meta charSet='utf-8' />
          <title>{metaTitle}</title>
          <link rel='canonical' href={metaUrl} />

          <meta name='description' content={metaDesc} />
          <meta property='og:title' content={metaTitle} />
          <meta property='og:description' content={metaDesc} />
          <meta property='og:url' content={metaUrl} />
          <meta property='og:type' content='article' />
          <meta property='og:image' content={metaImg} />
          <meta name='robots' content='noindex, nofollow' />
          <meta name='author' content='Benu GmbH' />

          <meta name='twitter:card' content={metaImg} />
          <meta name='twitter:site' content='@benu.at' />
          <meta name='twitter:creator' content='@benu.at' />
          <meta name='twitter:title' content={metaTitle} />
          <meta name='twitter:description' content={metaDesc} />
          <meta name='twitter:image' content={metaImg} />
        </Helmet>
        <PickupLocationInput />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/screens/wizard/acute/PickupScreen.tsx